<template>
  <div id="free-trial-vue1">
    <div class="container" v-if="isPCEnd">
      <!-- 左侧的描述 -->
      <div class="container-box">
        <div class="leftBox" :style="{'top': validStep === 1 ? '50px': lang === 'en' ? '80px' : '0'}">
          <div>
            <p class="left-title">{{$t('freedeploy')}}</p>
            <div class="platform"> 
              <div class="tab-item on-cloud-tab" :class="{'active': !deployonPrem}" @click="changeTabBar('on-cloud')">
                {{$t('freedeployoncloud')}}
              </div>
              <div class="tab-item on-premises" :class="{'active': deployonPrem}" @click="changeTabBar('on-premises')">
                {{$t('freedeployonprem')}}
              </div>
            </div>
            <!-- on-cloud begin -->
            <div class="on-cloud-section" style="width:89%" v-show="!deployonPrem">
              <div class="on-cloud-desc">{{$t('freedeployonclouddesc')}}</div>
              <!-- 这是第一步验证邮箱 -->
              <div v-if="!showStepTwoForm && validStep === 1 && !isLogin">
                <div class="field-container">
                  <el-form :model="dataEmail" :rules="rulesEmail"  status-icon ref="emailForm" style="flex: 1">
                    <el-form-item prop="email">
                      <el-input  v-model.trim="dataEmail.email" type="text" size="large" :placeholder="$t('yourWorkEmail')"></el-input>
                    </el-form-item>
                  </el-form>
                  <div style="margin-bottom: 12px;margin-top: 20px">
                    <input type="submit"  class="button red_btn hvr-round" :value="$t('deployNow')" style="margin-top: 5px;" @click="checkStep1Email">
                  </div>
                </div>
                <p class="click-here">{{$t('haveAccount1')}}<a :href="loginUrl" class="change-page">{{$t('haveAccount2')}}</a>{{$t('haveAccount3')}}</p>
              </div>
              <div v-if="showStepTwoForm && !isLogin">
                <el-form :model="dataOnCloud" :rules="rulesOnCloud"  status-icon ref="ruleFormOnCloud" class="trial-form">
                  <div style="display: flex;justify-content: space-between">
                    <el-form-item  prop="lastName" style="width: 48%">
                      <el-input v-model.trim="dataOnCloud.lastName" type="text" size="large" :placeholder="$t('fistName')"></el-input>
                    </el-form-item>
                    <el-form-item  prop="firstName" style="width: 48%">
                      <el-input v-model.trim="dataOnCloud.firstName" type="text" size="large" :placeholder="$t('lastName')"></el-input>
                    </el-form-item>
                  </div>
                  <el-form-item  prop="email" >
                    <el-input v-model.trim="dataOnCloud.email" type="text" size="large" :disabled="true" :placeholder="$t('yourWorkEmail')"></el-input>
                  </el-form-item>
                  <div style="display: flex;justify-content: flex-start;margin-bottom:24px">
                    <div class="country-drop">
                      <vue-country-code
                        :defaultCountry="countryCode"
                        :preferredCountries="defaultCountryArr"
                        @onSelect="onSelectOnCloud">
                      </vue-country-code>
                    </div>
                    <el-form-item  prop="intlTel" style="width: 87%">
                      <el-input v-model.trim="dataOnCloud.intlTel" type="text" size="large" :placeholder="$t('phoneNumber')"></el-input>
                    </el-form-item>
                  </div>
                </el-form>
                <div class="checkbox-con" style="display:flex;margin: 30px 0;">
                  <el-checkbox v-if="this.lang === 'zh-cn'" v-model="isCheckedOnCloud" @change="handleCheckChange"></el-checkbox>
                  <p :style="{'border-bottom': isAgreementCloud ? 'none' :'1px solid #e03b3b','font-size':'14px','margin-left':'5px'}">{{$t('clickSubmit')}}<a :href="$t('termsOfServiceLink')" class="change-page" target="_blank">{{$t('clickSubmit1')}}</a>{{$t('clickSubmit2')}}<a :href="$t('privacyPolicyLink')" class="change-page" target="_blank">{{$t('clickSubmit3')}}</a></p>
                </div>
                <div style="width: 100%;">
                  <input type="submit" id="submit_quick_trial_cloud" class="button red_btn hvr-round" :value="$t('createAcount')" style="margin-top: 0px" @click="validateForm">
                  <p style="margin-top: 20px;font-size :14px">{{$t('haveAccount1')}}&nbsp;<a :href="loginUrl" class="change-page">{{$t('haveAccount2')}}</a>{{$t('haveAccount3')}}</p>
                </div>
              </div>
              <!-- 使用本地 deploy && 已经登录（展示license） -->
              <div v-if="validStep === 3 && isLogin" class="license-con" style="margin-top: 20px">
                  <div class="license-text padding-none">
                    {{deployObj.msg}}
                  </div>
                  <a :href="routerToDeploy" target="_blank" class="button red_btn hvr-round" style="text-transform: none;margin-top: 20px;width: 100%;text-align:center;display:block">{{deployObj.btn_text}}</a>
                  <div class="contact-us">
                  <span>{{$t('contactUs')}}</span>
                  <a href="mailto:support@Kyligence.io">support@kyligence.io</a>
                </div>
              </div>
            </div>
            <!-- on-cloud end -->
            <!-- on-premises start -->
            <div class="on-prem-section" style="width:89%" v-show="deployonPrem">
              <div class="on-prem-desc">{{$t('freedeployonpremdesc')}}</div>
              <el-form :model="onPremData" :rules="rulesOnPrem"  status-icon ref="ruleOnPremForm" class="OnPremForm">
                <div style="display: flex;justify-content: space-between">
                  <el-form-item  prop="lastName" style="width: 48%">
                    <el-input v-model.trim="onPremData.lastName" type="text" size="large" :placeholder="$t('fistName')"></el-input>
                  </el-form-item>
                  <el-form-item  prop="firstName" style="width: 48%">
                    <el-input v-model.trim="onPremData.firstName" type="text" size="large" :placeholder="$t('lastName')"></el-input>
                  </el-form-item>
                </div>
                <el-form-item  prop="company" >
                  <el-input v-model.trim="onPremData.company" type="text" size="large" :placeholder="$t('yourCompany')"></el-input>
                </el-form-item>
                <el-form-item  prop="email" >
                  <el-input v-model.trim="onPremData.email" type="text" size="large" :placeholder="$t('yourWorkEmail')"></el-input>
                </el-form-item>
                <div style="display: flex;justify-content: flex-start;">
                  <div class="country-drop">
                  <vue-country-code
                    :defaultCountry="countryCode"
                    :preferredCountries="defaultCountryArr"
                    @onSelect="onSelectOnPrem">
                  </vue-country-code>
                  </div>
                  <el-form-item  prop="intlTel" style="width: 88%">
                    <el-input v-model.trim="onPremData.intlTel" type="text" size="large" :placeholder="$t('phoneNumber')"></el-input>
                  </el-form-item>
                </div>
              </el-form>
              <div  class="checkbox-con" style="display:flex;margin: 30px 0;">
                <el-checkbox v-if="this.lang === 'zh-cn'" v-model="isCheckedOnPrem" @change="handleCheckChangeOnPrem"></el-checkbox>
                <p :style="{'border-bottom': isAgreementOnPrem ? 'none' :'1px solid #e03b3b','font-size':'14px','margin-left':'5px'}">{{$t('clickSubmit')}}<a :href="$t('termsOfServiceLink')" class="change-page" target="_blank">{{$t('clickSubmit1')}}</a>{{$t('clickSubmit2')}}<a :href="$t('privacyPolicyLink')" class="change-page" target="_blank">{{$t('clickSubmit3')}}</a></p>
              </div>
              <div style="width: 100%;margin-top: 30px;">
                <input type="submit" id="submit_quick_trial_cloud" class="button red_btn hvr-round" :value="$t('applyForTrial')" style="margin-top: 0px" @click="validateFormOnPrem">
                <p style="margin-top: 20px;font-size :14px">{{$t('haveAccount1')}}&nbsp;<a :href="loginUrl" class="change-page">{{$t('haveAccount2')}}</a>{{$t('haveAccount3')}}</p>
              </div>
            </div>
            <!-- on-premises end -->
          </div>
        </div>
      </div>
      <!-- 右侧的表单的相关验证 -->
      <div class="container-box" :style="{'background': (validStep === 1 || validStep === 3) ? 'rgba(240, 241, 244, 0.5)' : '#fff','height': '906px','width': '45%','margin-left': '54px'}">
        <div :style="{'top': (validStep === 1 || validStep === 3) ? '45%':'','transform': (validStep === 1 || validStep === 3) ? 'translateY(-50%)':'', 'margin-top': lang === 'en' ? '100px': '16px'}" :class="(validStep === 1 || validStep === 3) ? 'validate-con-deploy': 'validate-con width-validate-con'">
          <div v-if="validStep === 1 || validStep === 3">
            <div class="on-cloud-right" v-show="!deployonPrem">
              <img :src="lang ==='en' ? 'https://siteprod-s3-cdn.kyligence.io/2022/03/1648191635-on_cloud_logo_en.png' :'https://siteprod-s3-cdn.kyligence.io/2022/03/1648095779-on_cloud_logo_cn.png'" width="80%"/>
              <p :style="{'margin-top': '44px!important','margin-bottom': '58px!important','padding-right': lang ==='en' ?'12px':'inherit','line-height':lang ==='en' ? '32px': 'inherit'}" class="ftS20">{{$t('deployTitle2')}}</p>
              <ul>
                <li class="test-drive-word">
                  <div>
                    <p class="li-top">{{$t('deployTitle21')}}</p>
                    <p class="li-bottom">{{$t('deployTitle22')}}</p>
                  </div>
                </li>
                <li class="test-drive-word top-icon">
                  <div>
                    <p class="li-top">{{$t('deployTitle23')}}</p>
                    <p class="li-bottom">{{$t('deployTitle24')}}</p>
                  </div>
                </li>
                <li class="test-drive-word third-icon">
                  <div>
                    <p class="li-top">{{$t('deployTitle25')}}</p>
                    <p class="li-bottom">{{$t('deployTitle26')}}</p>
                  </div>
                </li>
              </ul>
              <p :style="{'margin-top': '56px!important','padding-right': lang ==='en' ?'12px':'inherit','line-height':lang ==='en' ? '32px': 'inherit'}" class="choose-deploy">{{$t('deployDrive1')}}<a class="change-page" href="/zh/try">{{$t('deployDrive2')}}</a>{{$t('deployDrive3')}}</p>
                </div>
                <div class="on-premises-right" v-show="deployonPrem">
                <img src="https://siteprod-s3-cdn.kyligence.io/2022/03/1647416030-on_premises_illustrate.png" width="80%"/>
                <p :style="{'margin-top': '44px!important','margin-bottom': '58px!important','padding-right': lang ==='en' ?'12px':'inherit','line-height':lang ==='en' ? '32px': 'inherit'}" class="ftS20">{{$t('deployTitle2c')}}</p>
              <ul>
                <li class="test-drive-word">
                  <div>
                    <p class="li-top">{{$t('deployTitle21c')}}</p>
                    <p class="li-bottom">{{$t('deployTitle22c')}}</p>
                  </div>
                </li>
                <li class="test-drive-word top-icon">
                  <div>
                    <p class="li-top">{{$t('deployTitle23c')}}</p>
                    <p class="li-bottom">{{$t('deployTitle24c')}}</p>
                  </div>
                </li>
                <li class="test-drive-word third-icon">
                  <div>
                    <p class="li-top">{{$t('deployTitle25c')}}</p>
                    <p class="li-bottom">{{$t('deployTitle26c')}}</p>
                  </div>
                </li>
              </ul>
              <p :style="{'margin-top': '56px!important','padding-right': lang ==='en' ?'12px':'inherit','line-height':lang ==='en' ? '32px': 'inherit'}" class="choose-deploy">{{$t('deployDrive1')}}<a class="change-page" href="/zh/try">{{$t('deployDrive2')}}</a>{{$t('deployDrive3')}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isPCEnd" class="container-phone">
      <div class="moble-bg">
        <p class="not-support">{{$t('notSupportPhone')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import locales from './locales'
import { PhoneNumberUtil } from "google-libphonenumber"
import { Component } from 'vue-property-decorator'
import { transferTime } from './util'
@Component({
  locales
})

export default class renamePage extends Vue {
  deployonPrem = false
  showStepTwoForm = false

  isPCEnd = true
  isLogin = false

  regionCode = 86
  loader = null
  lang = ''
  globalApiUrl = ''
  defaultCountryArr = ['CN', 'US']
  countryCode = 'CN'

  dataEmail = {
    email: ''
  }

  deployObj = {}

  dataTotal = {
    firstName : '',
    lastName : '',
    company: '',
    email : '',
    password: '',
    confirmPassword: '',
  }
  dataOnCloud = {
    firstName : '',
    lastName : '',
    email : '',
    origin: ''
  }
  onPremData = {
    firstName: '',
    lastName: '',
    company: '',
    email: '',
    intlTel: ''
  }

  isCheckedOnCloud = false
  isCheckedOnPrem = false
  isAgreementCloud = true
  isAgreementOnPrem = true

  validStep = Number

  get loginUrl () {
    if (this.lang === 'en') {
      return 'https://kyligence.io/oauth2/?lang=en&from=https%3A%2F%2Fkyligence.io%2Ftry%2F'
    } else {
      return 'https://cn.kyligence.io/oauth2/?lang=zh-cn&from=https%3A%2F%2Fcn.kyligence.io%2Ftry%2F'
    }
  }
    
  get rulesEmail () {
    return {
      email: [
        {required: true, validator: this.validateStep1Email, trigger: 'blur' }
      ]
    }
  }
    
  get rulesOnCloud () {
    return {
      firstName: [
      { required: true, validator: this.validateFirstName, trigger: 'blur' }
    ],
    lastName: [
      { required: true, validator: this.validateLastName, trigger: 'blur' }
    ],
    email: [
      { required: true, validator: this.validateEmail, trigger: 'blur' }
    ],
    intlTel: [
      { required: true, validator: this.validateNumber, trigger: 'blur' }
    ],
    }
  }

  get rulesOnPrem(){
    return {
      firstName: [
        { required: true, validator: this.validateFirstName, trigger: 'blur' }
      ],
      lastName: [
        { required: true, validator: this.validateLastName, trigger: 'blur' }
      ],
      email: [
        { required: true, validator: this.validateEmail, trigger: 'blur' }
      ],
      intlTel: [
        { required: true, validator: this.validateNumber, trigger: 'blur' }
      ],
      company: [
        { required: true, validator: this.validateCompany, trigger: 'blur' }
      ]
    }
  }

  get routerToDeploy () {
    return this.lang === 'en' ? this.deployObj.btn_url +'?lang=en' : this.deployObj.btn_url + '?lang=zh'
  }

  changeTabBar(val){
    if(val === 'on-cloud') {
      this.deployonPrem = false
      window.location.hash = '#on-cloud'
    } else if(val === 'on-premises') {
      this.deployonPrem = true
      window.location.hash = '#on-prem'
    }
  }

  handleCheckChange() {
    this.isAgreementCloud = this.isCheckedOnCloud
  }

  handleCheckChangeOnPrem(){
    this.isAgreementOnPrem = this.isCheckedOnPrem
  }

  validateForm () {
    this.$refs.ruleFormOnCloud.validate((valid) => {
      this.isAgreementCloud = this.isCheckedOnCloud
      if (valid && this.isCheckedOnCloud) {
        this.createAccount()
      }
    })
  }

  validateFormOnPrem(){
    this.$refs.ruleOnPremForm.validate((valid) => {
      this.isAgreementOnPrem = this.isCheckedOnPrem
      if (valid && this.isCheckedOnPrem) {
        this.loader = $('.loader')
        this.loader.addClass('active')
        axios({
          method: 'post',
          url: this.globalApiUrl + '/wp-admin/admin-ajax.php',
          data: 'action=test_drive_check_email_request&' + `email=${this.onPremData.email.toLowerCase()}`
        }).then((response) => {
          this.loader.removeClass('active')
          if (response.data.status === 1) {
            this.createAccountOnPremises()
          } else {
            this.$message.error(response.data.errmsg)
          }
        }).catch((error) => {
          this.loader.removeClass('active')
          console.log(error)
        })
      }
    })
  }

  checkStep1Email () {
    this.$refs.emailForm.validate((valid) => {
      if (valid) {
        this.loader = $('.loader')
        this.loader.addClass('active')
        axios({
          method: 'post',
          url: this.globalApiUrl + '/wp-admin/admin-ajax.php',
          data: 'action=test_drive_check_email_request&' + `email=${this.dataEmail.email.toLowerCase()}`
        }).then((response) => {
          this.loader.removeClass('active')
          if (response.data.status === 1) {
            this.dataOnCloud.email = this.dataEmail.email.toLowerCase()
            this.showStepTwoForm = true
          } else {
            this.$message.error(response.data.errmsg)
          }
        }).catch((error) => {
          this.loader.removeClass('active')
          console.log(error)
        })
      }
    })
  }

  getQueryStringOnPremises () {
    return `lastName=${this.onPremData.lastName}&firstName=${this.onPremData.firstName}&intlTel=+${this.regionCode}${this.onPremData.intlTel}&email=${this.onPremData.email.toLowerCase()}&company=${this.onPremData.company}&lang=${this.lang}&regionCode=${this.countryCode}`
  }

  getQueryStringCloud () {
    return `lastName=${this.dataOnCloud.lastName}&firstName=${this.dataOnCloud.firstName}&intlTel=+${this.regionCode}${this.dataOnCloud.intlTel}&email=${this.dataOnCloud.email.toLowerCase()}&password=${this.dataOnCloud.password}&confirmPassword=${this.dataOnCloud.confirmPassword}&lang=${this.lang}&regionCode=${this.countryCode}&origin=${this.origin}`
  }

  getQueryStringHubspotCloud () {
    return [
      {name: 'lastname', value: this.dataOnCloud.lastName},
      {name: 'firstname', value: this.dataOnCloud.firstName},
      {name: 'phone', value: '+' + this.regionCode + this.dataOnCloud.intlTel},
      {name: 'email', value: this.dataOnCloud.email.toLowerCase()},
      {name: 'country', value: this.countryCode}
    ]
  }

  getQueryStringHubspotOnPrem () {
    return [
      {name: 'lastname', value: this.onPremData.lastName},
      {name: 'firstname', value: this.onPremData.firstName},
      {name: 'phone', value: '+' + this.regionCode + this.onPremData.intlTel},
      {name: 'email', value: this.onPremData.email.toLowerCase()},
      {name: 'country', value: this.countryCode},
      {name: 'company', value: this.onPremData.company}
    ]
  }

  getFieldsHubspot(){
    if (this.deployonPrem){
      return this.getQueryStringHubspotOnPrem()
    } else {
      return this.getQueryStringHubspotCloud()
    }
  }

  getFieldsSCRM(){
    if (this.deployonPrem){
      let str = this.getQueryStringOnPremises()
      return `${str}&source=23323&tag_str=c95092a9a7852c63`
    } else {
      let str = this.getQueryStringCloud()
      return `${str}&source=23324&tag_str=10c9d81468b7bea4`
    }
  }

  createAccount () {
    this.loader = $('.loader')
    this.loader.addClass('active')
    //英文站信息要同步提交到Hubspot
    if (this.lang === 'en'){
      this.createAccountEnToHubspot()
    }
    //中文站信息同步提交到SCRM
    if (this.lang === 'zh-cn'){
      this.createAccountToSCRM()
    }
    axios({
      method: 'post',
      url: this.globalApiUrl + '/wp-admin/admin-ajax.php',
      data: 'action=test_drive_check_user_info_request_oncloud&' + this.getQueryStringCloud()
    }).then((response) => {
      this.loader.removeClass('active')
      if (parseInt(response.data.status) === 1) {
        //console.log(response.data)
        if (this.lang === 'en') {
          window.open('https://kyligence.io/verifyemail-en/', '_self')
        } else {
          window.open('https://cn.kyligence.io/verifyemail-zh/', '_self')
        }
      } else {
          this.$message.error(response.errorMessage)
      }
    }).catch((error) => {
      this.loader.removeClass('active')
    })
  }

  createAccountOnPremises(){ 
    this.loader = $('.loader')
    this.loader.addClass('active')
    //英文站信息要同步提交到Hubspot
    if (this.lang === 'en'){
      this.createAccountEnToHubspot()
    }
    //中文站信息同步提交到SCRM
    if (this.lang === 'zh-cn'){
      this.createAccountToSCRM()
    }
    axios({
      method: 'post',
      url: this.globalApiUrl + '/wp-admin/admin-ajax.php',
      data: 'action=trial_enterprise_request&' + this.getQueryStringOnPremises ()
    }).then((response) => {
      this.loader.removeClass('active')
      if (parseInt(response.data.status) === 1) {
        if (this.lang === 'en') {
          window.open('https://kyligence.io/emailonprem-en/', '_self')
        } else {
          window.open('https://cn.kyligence.io/emailonprem-zh/', '_self')
        }
      }
    }).catch((error) => {
      this.loader.removeClass('active')
    })
  }

  createAccountEnToHubspot(){
    let hutk = document.cookie.replace(/(?:(?:^|.*;\s*)hubspotutk\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    let code = this.deployonPrem ? 'e01b0705-a487-4de8-a785-df09ecac4af4' : '2948f39c-30b7-43ab-a257-9e54cdb6a027'
    let submitURL = 'https://api.hsforms.com/submissions/v3/integration/submit/8461706/' + code;
    axios({
      method: 'post',
      url: submitURL,
      data: {
        "submittedAt": Date.now().toString(),
        "fields": this.getFieldsHubspot(),
        "context": {
            "hutk": hutk,
            "pageUri": window.location.href,
            "pageName": document.title
        }
      }
    }).then((response) => {
    }).catch((error) => {
      this.loader.removeClass('active')
    })
  }

  createAccountToSCRM(){
    axios({
      method: 'post',
      url: this.globalApiUrl + '/wp-admin/admin-ajax.php',
      data: 'action=subscribe_formdata_scrm&' + this.getFieldsSCRM () + '&pageUrl=' + window.location.href
    }).then((response) => {
      this.loader.removeClass('active')
    }).catch((error) => {
      this.loader.removeClass('active')
    })
  }
      
  validateStep1Email (rule, value, callback) {
    if (!value) {
      return callback(new Error('Work Email is required'))
    } else {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(value)) {
        return callback(new Error('Please enter a valid email address'))
      } else {
        return callback()
      }
    }
  }

  validateEmail (rule, value, callback) {
    if (!value) {
      return callback(new Error('Work Email is required'))
    } else {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(value)) {
        return callback(new Error('Please enter a valid email address'))
      } else {
        return callback()
      }
    }
  }

  validateFirstName (rule, value, callback) {
    if (!value) {
      return callback(new Error('First name is required'))
    }
    return callback()
  }

  validateLastName (rule, value, callback) {
    if (!value) {
      return callback(new Error('Last name is required'))
    }
    return callback()
  }

  validateCompany (rule, value, callback) {
    if (!value) {
      return callback(new Error('Company is required'))
    }
    return callback()
  }

  validateNumber (rule, value, callback) {
    if (!value) {
      return callback(new Error('Phone Number is required'))
    }
    const isNUmber = isNaN(value)
    const phoneUtil = !isNUmber && PhoneNumberUtil.getInstance()
    const number = !isNUmber && phoneUtil.parseAndKeepRawInput(value, this.countryCode)
    const isValite = !isNUmber && phoneUtil.isValidNumber(number)
    if (isNUmber) {
      return callback(new Error('Please enter a valid phone number'))
    } else if (!isValite) {
      return callback(new Error('Please enter a valid phone number'))
    }
    return callback()
  }

  getIsLogin () {
    this.loader = $('.loader')
    this.loader.addClass('active')
    axios({
      method: 'post',
      url: this.globalApiUrl + '/wp-admin/admin-ajax.php',
      data: 'action=is_user_login_request'
    }).then((response) => {
      if (parseInt(response.data.code) === 1) {
        this.validStep = 3
        this.isLogin = true
        this.getDeployClusterStatus()
      } else {
        this.loader.removeClass('active')
        this.validStep = 1
        this.isLogin = false
      }
    }).catch((error) => {
      this.loader.removeClass('active')
    })
  }

  // 这里是登录完成之后 选择 on-cloud deploy 方式 需要拿的文案和链接
  getDeployClusterStatus () {
    axios({
      method: 'post',
      url: this.globalApiUrl + '/wp-admin/admin-ajax.php',
      data: 'action=quick_trial_get_licence_request'
    }).then((response) => {
      this.loader.removeClass('active')
      if (response && response.data) {
        this.deployObj = response.data
      }
    }).catch((error) => {
      console.log(error)
    })
  }
  
  IsPC () {
    var userAgentInfo = navigator.userAgent
    var Agents = ['Android', 'iPhone', 'SymbianOS', 'Phone', 'iPad', 'iPod']
    var flag = true
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false
        break
      }
    }
    return flag
  }

  onSelectOnPrem({iso2, dialCode}){ 
    this.countryCode = iso2
    this.regionCode = dialCode
    let _field = this.$refs['ruleOnPremForm'].fields
    _field.map(i => {
      if (i.prop === 'intlTel') {
        i.clearValidate() 
        this.onPremData.intlTel = ''
        return false
      }
    })
  }

  onSelectOnCloud({iso2, dialCode}){ 
    this.countryCode = iso2
    this.regionCode = dialCode
    let _field = this.$refs['ruleFormOnCloud'].fields
    _field.map(i => {
      if (i.prop === 'intlTel') {
        i.clearValidate() 
        this.dataOnCloud.intlTel = ''
        return false
      }
    })
  }

  onSelect({name, iso2, dialCode}) {
    this.countryCode = iso2
    this.regionCode = dialCode
    let _field = this.$refs['ruleForm'].fields
    _field.map(i => {
      if (i.prop === 'intlTel') {
        i.clearValidate() 
        this.dataTotal.intlTel = ''
        return false
      }
    })
  }
     
  created () {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.isPCEnd = this.IsPC()
    this.globalApiUrl = window.location.origin
    this.origin = window.location.href + '?action=cloud-deploy-register'
    this.lang = document.documentElement.lang.includes('CN') ? 'zh-cn' : 'en'
    if (this.lang === 'zh-cn') {
      this.regionCode = 86
      this.countryCode = 'CN'
    } else {
      this.regionCode = 1
      this.countryCode = 'US'
      //checkbox is checked by default for en
      this.isCheckedOnCloud = true
      this.isCheckedOnPrem = true
    }
    this.getIsLogin()
    if (window.location.hash === '#on-prem'){
      this.changeTabBar('on-premises')
    } else {
      this.changeTabBar('on-cloud')
    }
  }
}
</script>


// WEBPACK FOOTER //
// App/components/renamePage/renamePage.vue